import { Flex } from 'antd';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router';
import { cn } from '../lib/cn';

const CustomNavigationItemSm = ({
  path,
  icon,
  label,
  isActive,
  onClick,
  classNames,
}: {
  path?: string;
  label: string;
  icon: ReactNode;
  isActive?: boolean;
  onClick?: () => void;
  classNames?: { button?: string; icon?: string; label?: string };
}) => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    if (path) navigate(path);
    if (onClick) onClick();
  };

  return (
    <button
      onClick={handleNavigate}
      data-selected={isActive}
      className={cn(
        'min-w-[25%] group flex flex-col items-center gap-[5px]',
        'data-[selected=true]:dark:text-theme-primary',
        classNames?.button,
      )}
    >
      <Flex
        align="center"
        justify="center"
        className={cn(
          'size-[31px] rounded-full transition-all duration-200',
          'bg-theme-slate-700 group-active:bg-theme-primary group-data-[selected=true]:bg-theme-primary group-data-[selected=true]:text-white',
        )}
      >
        {icon}
      </Flex>
      <h6
        className={cn(
          'text-xs font-medium text-wrap group-active:text-theme-primary max-w-[70px]',
        )}
      >
        {label}
      </h6>
    </button>
  );
};
export default CustomNavigationItemSm;
